// Help.tsx — contextual help primitives: HelpTip(인라인 ? 팝오버) + ScreenHelp(화면 사용법 패널).
// 포털/외부 의존성 없이 relative/absolute 포지셔닝과 useState 만 사용한다.
import { Icon } from "@/components/ui";
import { useState } from "react";

// 인라인 "?" 버튼 — 클릭 시 도움말 팝오버 토글, 재클릭/blur 로 닫힘.
export const HelpTip = ({ text }: { text: string }) => {
  const [open, setOpen] = useState(false);
  return (
    <span style={{ position: "relative", display: "inline-flex", verticalAlign: "middle" }}>
      <button
        type="button"
        aria-label="도움말"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        onBlur={() => setOpen(false)}
        style={{
          width: 16,
          height: 16,
          padding: 0,
          borderRadius: "50%",
          border: 0,
          background: open ? "var(--brand)" : "transparent",
          boxShadow: open ? "none" : "inset 0 0 0 1px var(--text-fainter)",
          color: open ? "#ffffff" : "var(--text-dim)",
          fontFamily: "inherit",
          fontSize: 10.5,
          fontWeight: 800,
          lineHeight: 1,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        ?
      </button>
      {open && (
        <span
          role="tooltip"
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            left: "50%",
            transform: "translateX(-50%)",
            width: 264,
            background: "var(--bg-surface-3)",
            color: "var(--text-near)",
            fontSize: 12.5,
            fontWeight: 400,
            lineHeight: 1.6,
            textAlign: "left",
            letterSpacing: "normal",
            textTransform: "none",
            whiteSpace: "normal",
            padding: "10px 13px",
            borderRadius: 12,
            boxShadow: "rgba(0,0,0,0.3) 0px 8px 24px, inset 0 0 0 1px var(--ring-input)",
            zIndex: 70,
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
};

// 화면 상단 접이식 도움말 패널 — 기본 접힘, 클릭 시 bullet 목록 펼침.
export const ScreenHelp = ({
  title = "이 화면 사용법",
  items,
}: {
  title?: string;
  items: string[];
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ background: "var(--bg-surface)", borderRadius: 16, overflow: "hidden" }}>
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 9,
          padding: "11px 16px",
          background: "transparent",
          border: 0,
          cursor: "pointer",
          fontFamily: "inherit",
          fontSize: 13,
          fontWeight: 700,
          color: open ? "var(--text-near)" : "var(--text-dim)",
          textAlign: "left",
        }}
      >
        <span
          aria-hidden="true"
          style={{
            width: 16,
            height: 16,
            borderRadius: "50%",
            boxShadow: "inset 0 0 0 1px var(--brand)",
            color: "var(--brand)",
            fontSize: 10,
            fontWeight: 800,
            lineHeight: 1,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          i
        </span>
        {title}
        <Icon
          name="chevD"
          size={14}
          style={{
            marginLeft: "auto",
            transform: open ? "rotate(180deg)" : "none",
            transition: "transform 120ms",
          }}
        />
      </button>
      {open && (
        <ul
          style={{
            margin: 0,
            padding: "2px 18px 14px 41px",
            display: "flex",
            flexDirection: "column",
            gap: 6,
            listStyle: "none",
          }}
        >
          {items.map((item) => (
            <li
              key={item}
              style={{
                position: "relative",
                paddingLeft: 14,
                fontSize: 12.5,
                color: "var(--text-muted)",
                lineHeight: 1.65,
              }}
            >
              <span
                aria-hidden="true"
                style={{
                  position: "absolute",
                  left: 0,
                  top: 8,
                  width: 5,
                  height: 5,
                  borderRadius: "50%",
                  background: "var(--brand)",
                }}
              />
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
